import type { wave } from '@round/api';
import { ExternalLink } from 'lucide-react';
import { PLATFORM_ICON, PLATFORM_LABEL } from '@/utility/campaignDisplay';
import PlatformIcon from '@/creator/components/PlatformIcon';

type Props = {
    audios: wave.InviteAudio[];
};

const AudioLinks = ({ audios }: Props) => (
    <div className="campaign-overview__audio-list">
        {audios.map((audio) => (
            <a
                className="campaign-overview__audio"
                href={audio.url}
                target="_blank"
                rel="noreferrer"
                aria-label={`Open ${audio.title} on ${PLATFORM_LABEL[audio.platform]}`}
                key={`${audio.platform}-${audio.url}`}
            >
                <span
                    className={`platform-logo platform-logo--${PLATFORM_ICON[audio.platform].toLowerCase()}`}
                    aria-hidden="true"
                >
                    <PlatformIcon platform={PLATFORM_ICON[audio.platform]} size={14} />
                </span>
                <span className="campaign-overview__audio-copy">
                    <strong>{audio.title}</strong>
                    <small>{audio.author_name || PLATFORM_LABEL[audio.platform]}</small>
                </span>
                <ExternalLink size={12} aria-hidden="true" />
            </a>
        ))}
    </div>
);

export default AudioLinks;
